import { __DEV__ } from "@/integrations/env";
import SentryUtils, { type SentryBreadcrumb } from "./sentry";

interface IErrorResponse {
  data: Record<string, string>;
  status: number;
  timestamp: string;
}

export interface IError {
  name?: string;
  message?: string;
  response?: IErrorResponse;
  stack?: string;
}

interface ILoggerInfo {
  section: string;
  flow: string;
  params?: Record<string, string | boolean | number>;
}

interface ILoggerError {
  section: string;
  message: unknown;
}

class Logger {
  buildErrorMessage(errorMessage: IError) {
    return {
      name: errorMessage?.name,
      message: errorMessage?.message,
      extraMessage: errorMessage?.response?.data?.message,
      status: errorMessage?.response ? errorMessage?.response?.status : 500,
      timestamp: new Date().toISOString(),
      ...(!__DEV__ && {
        stack: errorMessage?.stack,
      }),
    };
  }

  loggerError({ section, message: errorMessage }: ILoggerError) {
    const errorPayload = this.buildErrorMessage(
      errorMessage as unknown as IError,
    );
    if (__DEV__) {
      console.error(`${section}:`, JSON.stringify(errorPayload));
      return;
    }
    SentryUtils.captureException(section, errorMessage as Error);
  }

  loggerInfo({ section, flow, params = {} }: ILoggerInfo) {
    if (!__DEV__) {
      return;
    }
    console.info(
      `[${section?.toUpperCase()}] ---> ${flow?.toUpperCase()}: `,
      JSON.stringify(params),
    );
  }

  addBreadcrumb({
    category,
    message,
    level,
  }: SentryBreadcrumb) {
    SentryUtils.captureBreadcrumb({
      category,
      message,
      level,
    });
  }
}

export default new Logger();
